import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function (props) {
    return (
        <Row>
            <Col>
                <hr/>
            </Col>
            <Col className="col-auto">{props.text}</Col>
            <Col>
                <hr/>
            </Col>
        </Row>
    )
}



